import { useState } from 'react'
//import { useWallState } from "../../../../stateProviders/WallStateProvider"
import { EdgeTypeSubmenu } from '../EdgeTypeSubmenu'
import { ClickableLine } from './components/ClickableLine'
import { VisibleLine } from './components/VisibleLine'
import { WallDimensionDisplay } from './components/WallDimensionDisplay'

export const Wall = () => {
    const [wallActive, setWallActive] = useState(false)
    const [{wallClickX, wallClickY}, setWallClick] = useState({wallClickX:0, wallClickY:0})

    return (
        <g>
            <VisibleLine/>
            <ClickableLine 
                setWallActive={setWallActive}
                setWallClick={setWallClick}
            />
            <WallDimensionDisplay/>
            {wallActive && (
                <EdgeTypeSubmenu x={wallClickX} y={wallClickY}/>
            )}
        </g>
    )
}
